import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from "../../lib";
import { doPROJECT_EXTENSION_SET, doREQUEST_COMPLETE, doREQUEST_ERROR } from "../state";
import { getToken } from "./token_fetcher";

export const REQUEST_PROJECT_EXTENSION_LIST_FETCH = "REQUEST_PROJECT_EXTENSION_LIST_FETCH";
export const doREQUEST_PROJECT_EXTENSION_LIST_FETCH = createDoRequestAction(
  REQUEST_PROJECT_EXTENSION_LIST_FETCH,
);
export const requestProjectExtensionListFetchActionCreators = {
  doREQUEST_PROJECT_EXTENSION_LIST_FETCH,
};

export function* requestProjectExtensionListFetch({
  payload,
  setRequestResult,
}: any): SagaIterator {
  debug("saga*requestProjectExtensionListFetch");
  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        projectIds: v.array().items(v.string().uuid().exist()).required(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_EXTENSION_LIST_FETCH,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const { projectIds } = payload;

  const accessToken = yield call(getToken);
  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/project-extension-list-fetch`,
    accessToken,
    data: {
      projectIds,
    },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_EXTENSION_LIST_FETCH,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/project-extension-list-fetch",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(doPROJECT_EXTENSION_SET(result.payload));

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PROJECT_EXTENSION_LIST_FETCH,
        fromPayload: payload,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* projectExtensionListFetchSaga(): SagaIterator {
  yield takeEvery(REQUEST_PROJECT_EXTENSION_LIST_FETCH, requestProjectExtensionListFetch);
}
